import React from 'react';
import ky from 'ky';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Typography, Button } from '@material-ui/core';

import { getLoginCheckData } from '../redux/workBackendSlice';
import useWorkBackend from '../hooks/useWorkBackend';

import { apiURL } from '../components/DigimagiProvider';
import { setTokensToCookie } from '../general';

type DeleteGoodsDialogProps = {
  onClose: () => void;
  data?: { id: string, name: string };
}
const DeleteGoodsDialog: React.FC<DeleteGoodsDialogProps> = ({ onClose, data }) => {
  const authUser = useWorkBackend().authUser;

  const deleteExe = async () => {
    if (!data || !authUser || authUser === 'noAuth') return;
    try {
      const sendData = { goods_id: data.id };
      const loginCheckData = getLoginCheckData();
      const query = await ky.post(`${apiURL}delete_goods`, { json: { ...sendData, ...loginCheckData } }).json() as any;
      const newToken = query.data;
      if (newToken && typeof newToken === 'object') setTokensToCookie(newToken);
      onClose();
    } catch (err) {
      console.log(err);
    }
  }

  if (!data) return <></>;
  return (
    <Dialog open={Boolean(data)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <DialogTitle disableTypography>
          <Typography variant="h6">商品を削除する</Typography>
        </DialogTitle>
        <Typography variant="body2">{ data.name }</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>キャンセル</Button>
        <Button color="primary" onClick={deleteExe}>削除する</Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteGoodsDialog;
